import { render, staticRenderFns } from "./TipoBaja.vue?vue&type=template&id=6dc3ff18&scoped=true"
import script from "./TipoBaja.vue?vue&type=script&lang=js"
export * from "./TipoBaja.vue?vue&type=script&lang=js"
import style0 from "./TipoBaja.vue?vue&type=style&index=0&id=6dc3ff18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc3ff18",
  null
  
)

export default component.exports